import React, { useState, useEffect, useLayoutEffect } from "react";
import { useStyles } from "./styles";
import clsx from "clsx";
import { useParams } from "react-router-dom";
import AuthService from "../../services/AuthService";
import apiClient, { setAuthentication as setApiAuth } from "../../auth/apiClient";
import { setAuthenticationState } from "../../reducers/auth/authReducer";
import TicketlessValetRequest from "../../components/TicketlessValetRequest/TicketlessValetRequest";
import useAuthContext from "../../hooks/useAuthContext";
import { Grid, CircularProgress } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import GenericError from "../../components/MobilePayment/GenericError";

const authService = new AuthService(apiClient);

const TicketlessValetRequestPage = () => {
  const classes = useStyles();
  const { credentialId } = useParams();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { authReducer } = useAuthContext();
  const [, authDispatch] = authReducer;
  const theme = useTheme();

  const getAuth = async () => {
    try {
      const appClientToken = await authService.getMobilePayAuthToken();
      if (appClientToken !== "") {
        setApiAuth(appClientToken);
        authDispatch({
          type: setAuthenticationState,
          payload: { properties: [] },
        });
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Error Authenticating", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) {
      getAuth();
    }
  }, [authDispatch, isAuthenticated]);

  useLayoutEffect(() => {
    document.body.style.backgroundColor = theme.palette.background.level1;
  }, []);

  return (
    <div className={clsx(classes.root)}>
      <Grid container spacing={2} className={clsx(classes.logoContainer)}>
        <Grid item xs={12}>
          <img className={classes.logo} alt="company logo" src="/images/logos/a1-logo-stacked-dark.svg" />
        </Grid>
      </Grid>
      <div className={clsx(classes.contentContainer, "ticketless-valet-content")}>
        {isLoading === true ? (
          <CircularProgress size={60} className={clsx(classes.circularProgress)} />
        ) : credentialId && isAuthenticated ? (
          <TicketlessValetRequest credentialId={credentialId} />
        ) : (
          <GenericError message="Please try again"></GenericError>
        )}
      </div>
    </div>
  );
};

export default TicketlessValetRequestPage;
